module.exports = __webpack_public_path__ + "static/media/Tom-Riddle.57e0b7d3.jpg";